import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AmityUiKitProvider } from "@amityco/ui-kit-open-source";
import { Grid, CircularProgress } from "@mui/material";
import { MongoAbility, AbilityTuple, MongoQuery } from "@casl/ability";
import { RootState } from "../../state";
import defineAbilityFor from "../../permission/defineAbility";
import settings from "../../config/settings";

export const AmityProvider = ({ children }: { children: React.ReactNode }) => {
  const loginData = useSelector((state: RootState) => state.login);
  const [amityUser, setAmityUser] = useState<string>(
    settings.amity_default_user_id
  );
  const [amityUserName, setAmityUserName] = useState<string>(
    settings.amity_default_user_name
  );

  const [ability, setAbility] = useState<
    MongoAbility<AbilityTuple, MongoQuery> | undefined
  >(undefined);

  useEffect(() => {
    setAbility(defineAbilityFor(loginData));
  }, []);

  useEffect(() => {
    setAbility(defineAbilityFor(loginData));
    setAmityUser(String(loginData.userId));
    if (loginData.userName) {
      setAmityUserName(loginData.userName);
    }
  }, [loginData]);

  return ability !== undefined ? (
    <AmityUiKitProvider
      apiRegion={settings.amity_region}
      apiKey={settings.amity_api_key}
      userId={amityUser}
      displayName={amityUserName}
    >
      {children}
    </AmityUiKitProvider>
  ) : (
    <Grid container alignItems={"center"}>
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  );
};

export default AmityProvider;
